import { render, staticRenderFns } from "./Opt.vue?vue&type=template&id=05d946fe&scoped=true"
import script from "./Opt.vue?vue&type=script&lang=js"
export * from "./Opt.vue?vue&type=script&lang=js"
import style0 from "./Opt.vue?vue&type=style&index=0&id=05d946fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d946fe",
  null
  
)

export default component.exports